import React from 'react';

const SkeletonUpdate = () => (
  <div className="relative flex animate-pulse items-start gap-4">
    <div className="absolute left-[-21px] top-2 flex size-3 items-center justify-center">
      <span className="size-3 rounded-full bg-gray-300 ring-4 ring-white" />
    </div>
    <div className="w-full pl-2 pt-1 md:pl-6">
      <div className="mb-2 h-3 w-1/4 rounded bg-gray-300" />
      <div className="mb-2 h-4 w-1/2 rounded bg-gray-300" />
      <div className="h-3 w-full rounded bg-gray-200" />
      <div className="mt-1 h-3 w-3/4 rounded bg-gray-200" />
    </div>
  </div>
);

export default SkeletonUpdate;
